/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { Linking, Pressable, StyleSheet, Text, View } from 'react-native';
import { Divider } from 'react-native-elements-light';
//
import Image from '@web-components/common/Image';
import ImageBackground from '@web-components/common/ImageBackground';
import { downloadLink } from '~global/constants';
import { footer } from '~global/footer';
import { isNative } from '~global/screens';
import { useDownloadLink } from '~global/hooks';
import flex from '@web/styles/flex';
import Colors from '~global/Colors';

const footerTopBg = require('~assets/img/home/footer-top-bg-mobile.png');
const footerTopText = require('~assets/img/home/footer-top-text-mobile.png');
const downloadNow = require('~assets/img/home/download-now.png');
const downloads = [
  {
    link: downloadLink.appStore,
    uri: require('~assets/img/home/footer/btn-app-store-mobile.png'),
  },
  {
    link: downloadLink.playStore,
    uri: require('~assets/img/home/footer/btn-play-store-mobile.png'),
  },
];
const {
  socials,
  links,
  services,
  payments,
  safetyConsumers,
  customerCareConsumers,
} = footer;

const FooterMobileWeb = (props) => {
  const { navigation } = props;
  const handleDownloadLink = useDownloadLink();
  const handleDownloadApp = (link) => {
    if (link && !isNative) {
      window.dataLayer.push({
        event: 'Download Lilla',
        downloadLink: link,
      });
      Linking.openURL(link);
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.footerTop}>
        <ImageBackground
          style={styles.footerBackground}
          source={{ uri: footerTopBg }}>
          <Image
            style={styles.footerBackgroundText}
            source={{ uri: footerTopText }}
          />
        </ImageBackground>
      </View>
      <Text style={styles.slogan}>The First Ultimate App for Moms</Text>
      <Pressable style={styles.download} onPress={handleDownloadLink}>
        <Image style={styles.downloadButton} source={{ uri: downloadNow }} />
      </Pressable>
      <View style={[styles.flexRow, styles.marginBottom20]}>
        {downloads.map(({ link, uri }, index) => (
          <Pressable
            style={styles.appButton}
            key={index}
            onPress={() => handleDownloadApp(link)}>
            <Image style={styles.appsImage} source={{ uri }} />
          </Pressable>
        ))}
      </View>
      <View style={[styles.flexRow, styles.marginBottom20]}>
        {socials.map(({ key, uri }) => (
          <Pressable style={styles.socialButton} key={key}>
            <Image style={styles.socialImage} source={{ uri }} />
          </Pressable>
        ))}
      </View>
      <View
        style={[
          styles.flexRow,
          flex.flexWrap,
          { marginHorizontal: 'auto', width: 295 },
        ]}>
        {links.mobileWeb.map((item) => (
          <Pressable
            key={item.key}
            style={{ flexDirection: 'row' }}
            onPress={() => navigation.navigate(item.screen)}>
            <Text style={styles.linkText}>
              {item.name}
              {item.dot && ' · '}
            </Text>
          </Pressable>
        ))}
      </View>
      <Divider style={styles.divider} />
      <Text style={[styles.title, { textAlign: 'center' }]}>Customer Care</Text>
      <View style={styles.containerCustomerCareConsumers}>
        <Text style={styles.textCustomerCareConsumers}>
          {customerCareConsumers.title}
        </Text>
        <Text style={styles.textCustomerCareConsumers}>
          {customerCareConsumers.subTitle}
        </Text>
      </View>
      <View style={[styles.flexRow, flex.flexWrap, flex.justifyContentCenter]}>
        {services.map((item) => (
          <Pressable
            key={item.key}
            style={{ flexDirection: 'row' }}
            onPress={
              item.key == 'help-center'
                ? () => navigation.navigate(item.screen)
                : item.useLinking(item.link)
            }>
            <Text style={styles.linkText}>
              {item.name[0]}
              {item.name[1] && (
                <Text style={styles.linkTextBold}>{' ' + item.name[1]}</Text>
              )}
              {item.dot && ' · '}
            </Text>
          </Pressable>
        ))}
      </View>
      <Divider style={styles.divider} />
      <View style={styles.containerSafetyConsumers}>
        <Text style={styles.linkTextSafetyConsumers}>
          {safetyConsumers.titleMobile}
        </Text>
        <Pressable
          style={styles.flexRow}
          onPress={safetyConsumers.useLinking(safetyConsumers.link)}>
          <Text style={styles.safetyConsumersLinkText}>
            {safetyConsumers.contact} {safetyConsumers.subTitle}
          </Text>
        </Pressable>
      </View>
      <Divider style={styles.divider} />
      <Text style={[styles.title, { textAlign: 'center' }]}>
        Payment Options
      </Text>
      <View style={styles.payments}>
        {payments.map((_, index) =>
          payments[index].map((item, index) => (
            <Image
              key={index}
              style={styles.paymentImage}
              source={{
                uri: item.uri,
              }}
              resizeMode="contain"
            />
          )),
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 48,
  },
  divider: {
    marginHorizontal: 20,
    marginVertical: 20,
  },
  footerTop: {
    backgroundColor: Colors.purple26,
  },
  footerBackground: {
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  footerBackgroundText: {
    marginTop: 16,
    marginBottom: 16,
    height: 32,
  },
  slogan: {
    color: Colors.black,
    fontFamily: 'satoshi-bold',
    fontSize: 18,
    textAlign: 'center',
    marginTop: 16,
  },
  title: {
    color: Colors.purple7,
    fontFamily: 'satoshi-black',
    fontSize: 14,
    lineHeight: 17,
    marginBottom: 15,
  },
  download: {
    alignItems: 'center',
    marginVertical: 16,
  },
  downloadButton: {
    width: 138,
    height: 21,
  },
  flexRow: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  marginBottom20: {
    marginBottom: 20,
  },
  appButton: {
    marginLeft: 3,
    marginRight: 3,
  },
  appsImage: {
    width: 92,
    height: 30,
  },
  socialButton: {
    marginHorizontal: 8,
  },
  socialImage: {
    width: 20,
    height: 20,
  },
  linkText: {
    color: Colors.grey12,
    fontFamily: 'satoshi-medium',
    fontSize: 12,
    lineHeight: 25,
  },
  linkTextSafetyConsumers: {
    color: Colors.grey17,
    fontFamily: 'satoshi-medium',
    fontSize: 11,
    lineHeight: 18,
    textAlign: 'center',
  },
  linkTextBold: {
    color: Colors.purple30,
    fontFamily: 'satoshi-bold',
  },
  payments: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: 'auto',
    width: 300,
    paddingBottom: 20,
  },
  paymentImage: {
    marginLeft: 5,
    marginRight: 5,
    marginBottom: 10,
    height: 30,
    width: 50,
  },
  containerSafetyConsumers: {
    paddingHorizontal: 20,
  },
  safetyConsumersLinkText: {
    color: Colors.grey17,
    fontFamily: 'satoshi-bold',
    fontSize: 11,
    lineHeight: 18,
    textAlign: 'center',
  },
  containerCustomerCareConsumers: {
    paddingHorizontal: 20,
    paddingBottom: 10,
  },
  textCustomerCareConsumers: {
    color: Colors.grey17,
    fontFamily: 'satoshi-medium',
    fontSize: 11,
    lineHeight: 18,
    textAlign: 'center',
  },
});

export default FooterMobileWeb;
